import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Navbar from '../../components/common/Navbar';
import FooterTrustChat from '../../components/common/FooterTrustChat';

const useStyles = makeStyles(() => ({
    pageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        color: '#061522',
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '28px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '34px',
        marginTop: '30px',
        marginBottom: '0',
    },
    description: {
        color: '#556575',
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '22px',
        marginTop: '10px',
        marginBottom: '0',
    },
}));

export default function InvalidLink() {
    const classes = useStyles();

    return (
        <Box className={classes.pageWrapper}>
            <Navbar />
            <Box className={classes.container}>
                <Box className={classes.content}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                        <circle cx="40" cy="40" r="40" fill="#FFF1F0" />
                        <path d="M30 30L50 50" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M50 30L30 50" stroke="#FF4D4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                    <Typography className={classes.title}>Invalid invite link</Typography>
                    <Typography className={classes.description}>
                        This invitation link is not valid. Please check the<br />
                        link and try again.
                    </Typography>
                </Box>
            </Box>
            <FooterTrustChat />
        </Box>
    );
}
